<template>
  <base-layout>
    <div class="row height_100">
        <div class="col-md-12 admin-settings">
            <div class="settings-header">
                <h3 class="title">Settings</h3>
            </div>
            <div class="settings-body">
                <div class="col-md-2 height_100" style="padding:0">
                    <nav>
                        <ul class="nav">
                            <li :class="{'active': $route.name == 'employee-profile'}">                              
                                <router-link :to="routeToProfile" :class="{'router-link-exact-active router-link-active':$route.name == 'employee-profile'}">
                                   <img class="setting_img" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/Admin_settings/profile-settings.svg`" alt="Profile" width="20" />
                                  <img class="setting_img_hover" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/Admin_settings/profile-settings-hover.svg`" alt="Profile" width="20" />Profile Settings
                                  </router-link>
                            </li>
                             <li :class="{'active': $route.name == 'employee-timezone'}">                              
                                <router-link :to="routeToTimezone" :class="{'router-link-exact-active router-link-active':$route.name == 'employee-timezone'}">
                                   <img class="setting_img" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/Admin_settings/change-timezone.svg`" alt="Change-timezone" width="20" />
                                  <img class="setting_img_hover" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/Admin_settings/change-timezone-hover.svg`" alt="Change-timezone" width="20" />Change Timezone
                                </router-link>
                            </li>
                            <li :class="{'active': $route.name == 'employee-alerts'}">
                                <router-link :to="routeToAlerts" :class="{'router-link-exact-active router-link-active':$route.name == 'employee-alerts'}">
                                   <img class="setting_img" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/Admin_settings/Alerts.svg`" alt="Alerts" width="20" />
                                  <img class="setting_img_hover" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/Admin_settings/Alerts-hover.svg`" alt="Alerts" width="20" />Alerts
                                </router-link>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="col-md-10 height_100" style="border-left:1px solid #ddd;">
                    <div class="tab-content height_100">
                        <div class="tab-pane active height_100" id="profileSettings">
                          <router-view></router-view> 
                        </div>         
                    </div>
                </div>
            </div>
        </div>
    </div>
  </base-layout>
</template>
<script>
import jquery from "jquery";
export default {
  data() {
    return {
      activeTab: "profileSettings",
      routeToProfile: {
        name: "employee-profile",
        query: this.$route.query
      },
       routeToTimezone: {
        name: "employee-timezone",
        query: this.$route.query
      },
       routeToAlerts: {
        name: "employee-alerts",
        query: this.$route.query
      }
    };
  },

};
</script>
<style lang="scss" scoped>
@import "~styles/framework/vue-utils";
.height_100 {
  height: 100%;
}
.admin-settings {
  height: 100%;
  .settings-header {
    display: inline-block;
    width: 100%;
    padding: 0 0 10px;
    .title {
      color: #143361;
      font-weight: 700;
      margin: 0;
      font-size: 16px;
      line-height: 31px;
      float: left;
    }
    .back_btn {
      float: right;
      color: #fff;
      background-color: #143361;
      border-color: #10284c;
      padding: 6px 12px;
      font-size: 12px;
      line-height: 1.42857;
      border-radius: 4px;
    }
  }
  .settings-body {
    display: inline-block;
    width: 100%;
    background: #fff;
    height: calc(100% - 40px);
    nav {
      height: calc(100% - 10px);
      overflow: auto;
    }
    .nav > li {
      background: #fff;
      color: #143361;
      a {
        padding: 15px 0 15px 20px;
        list-style: none;
        clear: both;
        border-bottom: 1px solid #e2e2e4;
        cursor: pointer;
        border-left: 3px solid transparent;
        color: #8e8e8c;
        display: block;
        font-size: 13px;
        font-weight: normal;
      }
    }
    .setting_img_hover {
      display: none;
    }
    .nav > li.active {
      border: 0 !important;
      a {
        background: #f0f7ff;
        color: #143361;
      }
      .setting_img {
        display: none;
      }
      .setting_img_hover {
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/EmpSettings.vue